import React, { useEffect, useState } from 'react';
import {
  Box,
  ButtonIcon,
  Icon,
  MobileDrawer,
  ModalIsland,
  Typography,
} from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';
import { BULK_ACTION_ENDDATE } from '../mockData';

import BulkActionEndDateBody from './BulkActionEndDateBody';
import BulkActionEndDateFooter from './BulkActionEndDateFooter';
import BulkActionEndDateHeader from './BulkActionEndDateHeader';
import BulkActionEndDateSubTitle from './BulkActionEndDateSubTitle';
import invertedMessages from './messages';

import './BulkActionEndDate.css';

function BulkActionEndDate({
  bulkFooterStats,
  bulkActionEndDate,
  setBulkActionEndDate,
  handleEndDate,
  bulkPredefinedComments,
  isMobileXlargeWidth,
}) {
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const l = useInvertedLocalize(invertedMessages);

  const handleCloseBulkActionEndDate = () => {
    setBulkActionEndDate((prev) => ({
      ...prev,
      isOpen: false,
      hasAgreed: false,
      endDate: null,
      comment: '',
    }));
  };

  const handleCloseBukActionEndDateAlert = () => {
    setBulkActionEndDate((prev) => ({
      ...prev,
      showAlert: false,
    }));
  };

  const bulkActionApproveModal = classnames('BulkActionEndDateModal');

  useEffect(() => {
    if (!isMobileDrawerOpen && isMobileXlargeWidth)
      handleCloseBulkActionEndDate();
  }, [isMobileDrawerOpen]);

  useEffect(() => {
    setIsMobileDrawerOpen(bulkActionEndDate?.isOpen);
  }, [bulkActionEndDate?.isOpen]);

  // TODO: @Sagar, These classNames are very important to update!!
  if (isMobileXlargeWidth) {
    return (
      <MobileDrawer
        className='BulkActionEndDate-mobileDrawer'
        isOpen={isMobileDrawerOpen}
        setIsOpen={setIsMobileDrawerOpen}
        headerContent={
          <div className='ModalIsland-headerWrapper'>
            <div className='ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon'>
              <Icon kind='AlertWarningFilledSeparateColors' size='large' />
              <div className='ModalIsland-titleContainer'>
                <Typography
                  className='ModalIsland-title'
                  kind='h2'
                  desktop='h2-d'
                  mobile='h2-d'>
                  <BulkActionEndDateHeader
                    id={bulkActionEndDate?.id}
                    bulkFooterStats={bulkFooterStats}
                  />
                </Typography>
                <Typography
                  className='ModalIsland-subtitle'
                  kind='body2'
                  desktop='body2-d'
                  mobile='body2-d'>
                  <BulkActionEndDateSubTitle
                    id={bulkActionEndDate?.id}
                    bulkFooterStats={bulkFooterStats}
                  />
                </Typography>
              </div>
            </div>
            <Box tag='div' className='ModalIsland-closeBtn'>
              <ButtonIcon
                size='medium'
                kind='ghost'
                ariaLabel={l('Close')}
                icon={
                  <Icon kind='close' color='neutral-100' size='smallMedium' />
                }
                onClick={() => setIsMobileDrawerOpen(false)}
              />
            </Box>
          </div>
        }
        content={
          <BulkActionEndDateBody
            bulkActionEndDate={bulkActionEndDate}
            setBulkActionEndDate={setBulkActionEndDate}
            handleCloseBukActionEndDateAlert={handleCloseBukActionEndDateAlert}
            bulkPredefinedComments={bulkPredefinedComments}
          />
        }
        footerActionBar={
          <BulkActionEndDateFooter
            handleEndDate={handleEndDate}
            bulkActionEndDate={bulkActionEndDate}
            handleCloseBulkActionEndDate={handleCloseBulkActionEndDate}
          />
        }
      />
    );
  }

  return (
    <ModalIsland
      className={bulkActionApproveModal}
      onClose={
        bulkActionEndDate?.isSubmitting
          ? () => {}
          : handleCloseBulkActionEndDate
      }
      isOverflowVisible
      isOpen={bulkActionEndDate?.isOpen}
      headerIcon={<Icon kind='AlertWarningFilledSeparateColors' size='large' />}
      title={
        <BulkActionEndDateHeader
          id={bulkActionEndDate?.id}
          bulkFooterStats={bulkFooterStats}
        />
      }
      subtitle={
        <BulkActionEndDateSubTitle
          id={bulkActionEndDate?.id}
          bulkFooterStats={bulkFooterStats}
        />
      }
      contentBody={
        <BulkActionEndDateBody
          bulkActionEndDate={bulkActionEndDate}
          setBulkActionEndDate={setBulkActionEndDate}
          handleCloseBukActionEndDateAlert={handleCloseBukActionEndDateAlert}
          bulkPredefinedComments={bulkPredefinedComments}
        />
      }
      FooterActionBarComp={
        <BulkActionEndDateFooter
          handleEndDate={handleEndDate}
          bulkActionEndDate={bulkActionEndDate}
          handleCloseBulkActionEndDate={handleCloseBulkActionEndDate}
        />
      }
    />
  );
}

BulkActionEndDate.propTypes = {
  bulkFooterStats: PropTypes.shape({}),
  bulkActionEndDate: PropTypes.shape(BULK_ACTION_ENDDATE).isRequired,
  setBulkActionEndDate: PropTypes.func.isRequired,
  handleEndDate: PropTypes.func.isRequired,
  bulkPredefinedComments: PropTypes.arrayOf(PropTypes.string),
  isMobileXlargeWidth: PropTypes.bool,
};

BulkActionEndDate.defaultProps = {
  bulkFooterStats: {},
  bulkPredefinedComments: [],
  isMobileXlargeWidth: false,
};

export default BulkActionEndDate;
